var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "products",
    "data-name": "products",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M164.85,165.77H91.79V92.71h73.06Zm-58.06-15h43.06V107.71H106.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M72.76,73.68H-.3V.62H72.76Zm-58.06-15H57.76V15.62H14.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M164.85,255.85H91.79v-73h73.06Zm-58.06-15h43.06v-43H106.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M72.76,165.77H-.3V92.71H72.76Zm-58.06-15H57.76V107.71H14.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M72.76,255.85H-.3v-73H72.76Zm-58.06-15H57.76v-43H14.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M255.94,73.68H182.88V.62h73.06Zm-58.06-15h43.06V15.62H197.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M164.85,73.68H91.79V.62h73.06Zm-58.06-15h43.06V15.62H106.79Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M255.94,165.77H182.88V92.71h73.06Zm-58.06-15h43.06V107.71H197.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "products-1",
    d: "M255.94,255.85H182.88v-73h73.06Zm-58.06-15h43.06v-43H197.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/icon-products.0287ab48.svg";
export { ForwardRef as ReactComponent };